import {askFor} from './Utils';
export const NIU_HANDS=[['a','闲家A'],['b','闲家B'],['d','闲家D'],['banker','庄']];
export const NIU_WINDOW=60;
export const niuLabel=askFor;
export function niuValues(numbers) {
  return {a:numbers[0],b:numbers[1],d:(numbers[0]+numbers[1])%10,banker:numbers[2]};
}
export function niuStatistics(history,hand) {
  const sample=history.slice(0,NIU_WINDOW);
  const values=sample.map(draw=>niuValues(draw.numbers)[hand]);
  const latest=values[0];
  const following=sample.slice(1).flatMap((draw,i)=>values[i+1]===latest&&Number(sample[i].issue)-Number(draw.issue)===1?[values[i]]:[]);
  const rows=Array.from({length:10},(_,value)=>({value,count:values.filter(n=>n===value).length,missing:values.includes(value)?values.indexOf(value):sample.length,next:following.filter(n=>n===value).length}));
  const gap=sample.some((draw,i)=>i>0&&Number(sample[i-1].issue)-Number(draw.issue)!==1);
  const mode=!values.length?'default':following.length>=5&&!gap?'smoothed':'baseline';
  const ranked=rows.map(row=>({...row,score:mode==='smoothed'?(row.next+20*(row.count+1)/(values.length+10))/(following.length+20):(row.count+1)/(values.length+10)})).sort((a,b)=>b.score-a.score||a.value-b.value);
  const next=[...rows].sort((a,b)=>b.next-a.next||a.value-b.value);
  return {latest,total:sample.length,followingTotal:following.length,rows,prediction:ranked[0].value,mode,
    next:following.length?next.filter(row=>row.next===next[0].next):[],
    cold:[...rows].sort((a,b)=>a.count-b.count||b.missing-a.missing||a.value-b.value).slice(0,3)};
}
export function niuResults(numbers) {
 const values=niuValues(numbers),rank=value=>value===0?10:value;
 const outcomes=Object.fromEntries(['a','b','d'].map(hand=>[hand,rank(values[hand])>rank(values.banker)?'赢':'输']));
 return {values,outcomes,bankerWins:Object.values(outcomes).filter(value=>value==='输').length};
}
export function niuDragons(history,hand) {
 const sample=history.slice(0,NIU_WINDOW);
 const modes=[['cow','牛值',draw=>niuValues(draw.numbers)[hand]]];
 if(hand!=='banker') modes.push(['outcome','胜负',draw=>niuResults(draw.numbers).outcomes[hand]]);
 return modes.flatMap(([id,label,valueOf])=>{
  const values=[];
  for(let i=0;i<sample.length;i++) {
   if(i>0&&Number(sample[i-1].issue)-Number(sample[i].issue)!==1) break;
   values.push(valueOf(sample[i]));
  }
  return [[1,3,'连续'],[2,4,'交替'],[3,6,'ABB循环']].flatMap(([period,minimum,type])=>{
   if(values.length<minimum||(period>1&&new Set(values.slice(0,period)).size!==2)) return [];
   let count=period;
   while(count<values.length&&values[count]===values[count%period]) count++;
   return count<minimum?[]:[{id:`${id}:${period}`,label,type,count,sequence:values.slice(0,count).reverse(),start:sample[count-1].issue,end:sample[0].issue}];
  });
 });
}
